<div class="content content-fixed">
  <div class="container">
    <div class="page-title-box d-sm-flex align-items-center justify-content-between mb-3">
      <h4 class="mb-0">{{'Audit Log' | translate}}</h4>
    </div>
    <div class="card mt-3" *ngIf="!isLoading">
	  <div class="card-header p-2">
		<div class="table-responsive">
			<div class="d-flex">
				<div class="col-sm-4 p-2">
					<label class="font-weight-bold">{{'USERS' | translate}}</label>
					<select class="form-control" (change)="selectedUser($event)">
						<option>All</option>
						<option *ngFor="let opt of data.all_users" [value]="opt">{{opt}}</option>
					</select>
				</div>
				<div class="col-sm-4 p-2">
					<label class="font-weight-bold">{{'DATASOURCES' | translate}}</label>
					<select class="form-control" (change)="selectedDatasource($event)">
						<option>All</option>
						<option *ngFor="let opt of data.all_ds" [value]="opt">{{opt}}</option>
					</select>
				</div>
				<div class="col-sm-4 p-2">
					<label class="font-weight-bold">{{'TIMESTAMP' | translate}}</label>
					<select class="form-control" (change)="selectedTime($event)">
						<option>All</option>
						<option *ngFor="let date of timeStamp" [value]="date">{{date}}</option>
					</select>
				</div>
			</div>
		
		</div>
	</div>

<table class="table standard-table standard-table-bordered table-striped">
        <thead>
			<tr class="text-center">
				<th (click)="userNameSorting(nameSelected)">{{'Username' | translate}}
					<span class="float-right cursor-pointer">
						<app-svg-icons *ngIf="userasc" [iconName]="'arrow-up'"></app-svg-icons>
						<app-svg-icons *ngIf="!userasc" [iconName]="'arrow-down'"></app-svg-icons>
					</span>
				</th>
				<th (click)="entityNameSorting(entityNameSelected)">{{'ENTITY NAME' | translate}}
					<span class="float-right cursor-pointer">
						<app-svg-icons *ngIf="entityasc" [iconName]="'arrow-up'"></app-svg-icons>
						<app-svg-icons *ngIf="!entityasc" [iconName]="'arrow-down'"></app-svg-icons>
					</span>
				</th>
				<th (click)="sorceSorting(sourceSelected)">{{'Datasource' | translate}}
					<span class="float-right cursor-pointer">
						<app-svg-icons *ngIf="sourceasc" [iconName]="'arrow-up'"></app-svg-icons>
						<app-svg-icons *ngIf="!sourceasc" [iconName]="'arrow-down'"></app-svg-icons>
					</span>
				</th>
				<th (click)="timeSorting(timeSelected)">{{'TIMESTAMP' | translate}}
					<span class="float-right cursor-pointer">
						<app-svg-icons *ngIf="timeasc" [iconName]="'arrow-up'"></app-svg-icons>
						<app-svg-icons *ngIf="!timeasc" [iconName]="'arrow-down'"></app-svg-icons>
					</span>
				</th>
			</tr>
	</thead>
	<tbody>
		<tr *ngFor="let data of tableData | paginate: { itemsPerPage: 10, currentPage: p }">
			<td>{{data.name}}</td>
			<td>{{data.entityName}}</td>
			<td>{{data.dataSource}}</td>
			<td>{{data.timeStamp}}</td>
		</tr>
		</tbody>
		<tbody *ngIf="tableData && tableData.length == 0">
			<tr><td class="no-data-available" colspan="4">{{'No Match Found' | translate}}</td></tr>
		</tbody>
	  </table>

		<div class="card-footer p-2">
			<span class="float-right">
				<pagination-controls (pageChange)="p = $event"></pagination-controls>
			</span>
		</div>
  </div>
</div>
<app-spinner *ngIf="isLoading" class="spinner-position"></app-spinner>
